module.exports = __webpack_public_path__ + "static/media/sine.4d7bdb43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sine.svg
// module id = 226
// module chunks = 0